"use client"

import { FormattedMessage } from "react-intl"

import {
  Button,
  IconButton,
  IconProps,
  P,
  TextButton,
  TextButtonProps,
} from "@bullseye/components"

import { useHandleShare } from "../../hooks"

type Props = {
  url: string
  emailSubject: string
  message: string
  variant?: TextButtonProps["variant"]
  outlined?: boolean
  buttonType?: "text" | "button" | "icon"
  labelId?: string
  startIconType?: IconProps["type"]
  underlined?: boolean
  onPress?: () => void
}

export const ShareButton = ({
  emailSubject,
  message,
  url,
  variant = "tertiary",
  outlined = false,
  buttonType = "text",
  labelId = "general.share",
  startIconType = "share",
  underlined,
  onPress,
}: Props) => {
  const handleShare = useHandleShare()

  if (buttonType === "icon") {
    return (
      <IconButton
        iconType="share"
        name="Share"
        handlePress={() => {
          onPress?.()
          void handleShare({ emailSubject, message, url })
        }}
      />
    )
  }

  const ButtonElement = buttonType === "text" ? TextButton : Button

  return (
    <ButtonElement
      as="button"
      startIconType={startIconType}
      variant={variant}
      outlined={outlined}
      underlined={underlined}
      handlePress={(e) => {
        e.preventDefault()
        onPress?.()
        return handleShare({ emailSubject, message, url })
      }}
    >
      <P bold>
        <FormattedMessage id={labelId} />
      </P>
    </ButtonElement>
  )
}
